import { render, staticRenderFns } from "./batch-case.vue?vue&type=template&id=b2cb5958"
import script from "./batch-case.vue?vue&type=script&lang=ts"
export * from "./batch-case.vue?vue&type=script&lang=ts"
import style0 from "./batch-case.vue?vue&type=style&index=0&id=b2cb5958&prod&lang=less&s=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports